import React from 'react';
import './Static.css';

const ThankYou = () => {
  return (
    <div>
      <h2>Thank you for registering to vote.</h2>
      <h3>Research candidates and laws before voting.</h3>
    </div>
  )
}

export default ThankYou;



// WEBPACK FOOTER //
// ./src/components/staticComponents/ThankYou.js